import view from 'bundle-text:../dom/dashboard.html';
import app from './app';

export default () => {
  const content = document.createElement('div');

  content.classList.add(
    'w-100',
  );
  content.innerHTML = view;

  document.title = `${app.run.settings.view.dashboard.pageTitle}${app.run.settings.siteTitleSeparator}${app.run.settings.siteTitle}`;

  new Chart(content.querySelector('#app-chart-dashboard-activity'), {
    type: 'bar',
    //data [99],
    data: {
      //labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
      datasets: [{
        label: '# of Votes',
        data: [170, 10],
        borderWidth: 1
      }]
    },
    options: {
        rotation: -90,
        circumference: 180,
        /*
      scales: {
        y: {
          beginAtZero: true
        }
      }
        */
    }
  });
  /*
  var chart = new Chart(canvas, {
  type: 'doughnut',
  data: ['400', '200'],
  options: {
    rotation: -90,
    circumference: 180,
  }
}  */

  const ctx = content.querySelector('#test');

  /*
  var chart = new Chart(ctx, {
      type: 'doughnut',
      data: ['400', '200'],
      options: {
        rotation: -90,
        circumference: 180,
      } 
    });
    */

  new Chart(ctx, {
    type: 'doughnut',
    //data [99],
    data: {
      //labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
      datasets: [{
        label: '# of Votes',
        data: [170, 10],
        borderWidth: 1
      }]
    },
    options: {
        rotation: -90,
        circumference: 180,
        /*
      scales: {
        y: {
          beginAtZero: true
        }
      }
        */
    }
  });
  return content;
};
